import { Box, useTheme } from '@mui/material';
import { Dialogue, SingleSelect } from '@components/molecules';
import { Button, Typography, KeyValuePair } from '@components/atoms';
import { EditDocumentCategoryModalProps } from './EditDocumentCategoryModal.props';

export const EditDocumentCategoryModal = ({
  open,
  onClose,
  documentName,
  documentCategory,
  documentTypeOptions,
  selectedDocumentType,
  onDocumentTypeChange,
  categoryNameOptions,
  selectedCategoryName,
  onCategoryNameChange,
  onSave,
  loading = false,
  title = 'Edit Document Category',
  ...dialogProps
}: EditDocumentCategoryModalProps) => {
  const theme = useTheme();

  const handleSave = () => {
    onSave();
  };

  const isSaveDisabled =
    loading ||
    selectedDocumentType === undefined ||
    selectedDocumentType === '' ||
    selectedCategoryName === undefined ||
    selectedCategoryName === '';

  const actions = (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Button variant="text" onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button variant="filled" onClick={handleSave} disabled={isSaveDisabled}>
        {loading ? 'Saving...' : 'Save'}
      </Button>
    </Box>
  );

  const ModifiedKeyValuePair = ({
    label,
    value,
  }: {
    label: string;
    value: string;
  }) => {
    return (
      <KeyValuePair
        label={
          <Typography sx={theme.typography.M3.body.small}>{label}</Typography>
        }
        value={
          <Typography sx={theme.typography.M3.body.large}>{value}</Typography>
        }
        spacing="md"
        fullWidth
        direction="vertical"
        align="flex-start"
      />
    );
  };

  return (
    <Dialogue
      open={open}
      onClose={onClose}
      title={title}
      actions={actions}
      showClose
      maxWidth="sm"
      fullWidth
      {...dialogProps}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.unit(6) }}
      >
        <ModifiedKeyValuePair label="Document Name" value={documentName} />

        <ModifiedKeyValuePair
          label="Document Category"
          value={documentCategory}
        />

        {/* Selection Section */}
        <SingleSelect
          label="Select Document Type"
          options={documentTypeOptions}
          value={selectedDocumentType}
          onChange={onDocumentTypeChange}
          required
        />

        <SingleSelect
          label="Category Name"
          options={categoryNameOptions}
          value={selectedCategoryName}
          onChange={onCategoryNameChange}
          required
        />
      </Box>
    </Dialogue>
  );
};

export default EditDocumentCategoryModal;
